import _possibleConstructorReturn from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { signProfileToken, extractProfile } from './profileTokens';
import { getPersonFromLegacyFormat } from './profileSchemas';
import { getName, getFamilyName, getGivenName, getAvatarUrl, getDescription, getVerifiedAccounts, getAddress, getBirthDate, getConnections, getOrganizations } from './profileSchemas/personUtils';
import { makeZoneFile, parseZoneFile } from 'zone-file';
import * as inspector from 'schema-inspector';
import { Logger } from '@stacks/common';
import { createFetchFn } from '@stacks/network';
var schemaDefinition = {
  type: 'object',
  properties: {
    '@context': {
      type: 'string',
      optional: true
    },
    '@type': {
      type: 'string'
    }
  }
};
export var Profile =
/*#__PURE__*/
function () {
  function Profile() {
    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Profile);

    this._profile = Object.assign({}, {
      '@context': 'http://schema.org/'
    }, profile);
  }

  _createClass(Profile, [{
    key: "toJSON",
    value: function toJSON() {
      return Object.assign({}, this._profile);
    }
  }, {
    key: "toToken",
    value: function toToken(privateKey) {
      return signProfileToken(this.toJSON(), privateKey);
    }
  }], [{
    key: "validateSchema",
    value: function validateSchema(profile) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      schemaDefinition.strict = strict;
      return inspector.validate(schemaDefinition, profile);
    }
  }, {
    key: "fromToken",
    value: function fromToken(token) {
      var publicKeyOrAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var profile = extractProfile(token, publicKeyOrAddress);
      return new Profile(profile);
    }
  }, {
    key: "makeZoneFile",
    value: function makeZoneFile(domainName, tokenFileURL) {
      return makeProfileZoneFile(domainName, tokenFileURL);
    }
  }]);

  return Profile;
}();
var personSchemaDefinition = {
  type: 'object',
  strict: false,
  properties: {
    '@context': {
      type: 'string',
      optional: true
    },
    '@type': {
      type: 'string'
    },
    '@id': {
      type: 'string',
      optional: true
    },
    name: {
      type: 'string',
      optional: true
    },
    givenName: {
      type: 'string',
      optional: true
    },
    familyName: {
      type: 'string',
      optional: true
    },
    description: {
      type: 'string',
      optional: true
    },
    image: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          name: {
            type: 'string',
            optional: true
          },
          contentUrl: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    website: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          url: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    account: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          service: {
            type: 'string',
            optional: true
          },
          identifier: {
            type: 'string',
            optional: true
          },
          proofType: {
            type: 'string',
            optional: true
          },
          proofUrl: {
            type: 'string',
            optional: true
          },
          proofMessage: {
            type: 'string',
            optional: true
          },
          proofSignature: {
            type: 'string',
            optional: true
          }
        }
      }
    },
    worksFor: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          '@id': {
            type: 'string',
            optional: true
          }
        }
      }
    },
    knows: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        properties: {
          '@type': {
            type: 'string'
          },
          '@id': {
            type: 'string',
            optional: true
          }
        }
      }
    },
    address: {
      type: 'object',
      optional: true,
      properties: {
        '@type': {
          type: 'string'
        },
        streetAddress: {
          type: 'string',
          optional: true
        },
        addressLocality: {
          type: 'string',
          optional: true
        },
        postalCode: {
          type: 'string',
          optional: true
        },
        addressCountry: {
          type: 'string',
          optional: true
        }
      }
    },
    birthDate: {
      type: 'string',
      optional: true
    },
    taxID: {
      type: 'string',
      optional: true
    }
  }
};
export var Person =
/*#__PURE__*/
function (_Profile) {
  _inherits(Person, _Profile);

  function Person() {
    var _this;

    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      '@type': 'Person'
    };

    _classCallCheck(this, Person);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Person).call(this, profile));
    _this._profile = Object.assign({}, {
      '@type': 'Person'
    }, _this._profile);
    return _this;
  }

  _createClass(Person, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        profile: this.profile(),
        name: this.name(),
        givenName: this.givenName(),
        familyName: this.familyName(),
        description: this.description(),
        avatarUrl: this.avatarUrl(),
        verifiedAccounts: this.verifiedAccounts(),
        address: this.address(),
        birthDate: this.birthDate(),
        connections: this.connections(),
        organizations: this.organizations()
      };
    }
  }, {
    key: "profile",
    value: function profile() {
      return Object.assign({}, this._profile);
    }
  }, {
    key: "name",
    value: function name() {
      return getName(this.profile());
    }
  }, {
    key: "givenName",
    value: function givenName() {
      return getGivenName(this.profile());
    }
  }, {
    key: "familyName",
    value: function familyName() {
      return getFamilyName(this.profile());
    }
  }, {
    key: "description",
    value: function description() {
      return getDescription(this.profile());
    }
  }, {
    key: "avatarUrl",
    value: function avatarUrl() {
      return getAvatarUrl(this.profile());
    }
  }, {
    key: "verifiedAccounts",
    value: function verifiedAccounts(verifications) {
      return getVerifiedAccounts(this.profile(), verifications);
    }
  }, {
    key: "address",
    value: function address() {
      return getAddress(this.profile());
    }
  }, {
    key: "birthDate",
    value: function birthDate() {
      return getBirthDate(this.profile());
    }
  }, {
    key: "connections",
    value: function connections() {
      return getConnections(this.profile());
    }
  }, {
    key: "organizations",
    value: function organizations() {
      return getOrganizations(this.profile());
    }
  }], [{
    key: "validateSchema",
    value: function validateSchema(profile) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      personSchemaDefinition.strict = strict;
      return inspector.validate(schemaDefinition, profile);
    }
  }, {
    key: "fromToken",
    value: function fromToken(token) {
      var publicKeyOrAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var profile = extractProfile(token, publicKeyOrAddress);
      return new Person(profile);
    }
  }, {
    key: "fromLegacyFormat",
    value: function fromLegacyFormat(legacyProfile) {
      var profile = getPersonFromLegacyFormat(legacyProfile);
      return new Person(profile);
    }
  }]);

  return Person;
}(Profile);
export function makeProfileZoneFile(origin, tokenFileUrl) {
  if (!tokenFileUrl.includes('://')) {
    throw new Error('Invalid token file url');
  }

  var urlScheme = tokenFileUrl.split('://')[0];
  var urlParts = tokenFileUrl.split('://')[1].split('/');
  var domain = urlParts[0];
  var pathname = "/".concat(urlParts.slice(1).join('/'));
  var zoneFile = {
    $origin: origin,
    $ttl: 3600,
    uri: [{
      name: '_http._tcp',
      priority: 10,
      weight: 1,
      target: "".concat(urlScheme, "://").concat(domain).concat(pathname)
    }]
  };
  var zoneFileTemplate = '{$origin}\n{$ttl}\n{uri}\n';
  return makeZoneFile(zoneFile, zoneFileTemplate);
}
export function getTokenFileUrl(zoneFileJson) {
  if (!zoneFileJson.hasOwnProperty('uri')) {
    return null;
  }

  if (!Array.isArray(zoneFileJson.uri)) {
    return null;
  }

  if (zoneFileJson.uri.length < 1) {
    return null;
  }

  var validRecords = zoneFileJson.uri.filter(function (record) {
    return record.hasOwnProperty('target') && record.name === '_http._tcp';
  });

  if (validRecords.length < 1) {
    return null;
  }

  var firstValidRecord = validRecords[0];

  if (!firstValidRecord.hasOwnProperty('target')) {
    return null;
  }

  var tokenFileUrl = firstValidRecord.target;

  if (tokenFileUrl.startsWith('https')) {} else if (tokenFileUrl.startsWith('http')) {} else {
    tokenFileUrl = "https://".concat(tokenFileUrl);
  }

  return tokenFileUrl;
}
export function resolveZoneFileToProfile(zoneFile, publicKeyOrAddress) {
  var fetchFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createFetchFn();
  return new Promise(function (resolve, reject) {
    var zoneFileJson = null;

    try {
      zoneFileJson = parseZoneFile(zoneFile);

      if (!zoneFileJson.hasOwnProperty('$origin')) {
        zoneFileJson = null;
      }
    } catch (e) {
      reject(e);
    }

    var tokenFileUrl = null;

    if (zoneFileJson && Object.keys(zoneFileJson).length > 0) {
      tokenFileUrl = getTokenFileUrl(zoneFileJson);
    } else {
      try {
        return resolve(Person.fromLegacyFormat(JSON.parse(zoneFile)).profile());
      } catch (error) {
        return reject(error);
      }
    }

    if (tokenFileUrl) {
      fetchFn(tokenFileUrl).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        return JSON.parse(responseText);
      }).then(function (responseJson) {
        var tokenRecords = responseJson;
        var profile = extractProfile(tokenRecords[0].token, publicKeyOrAddress);
        resolve(profile);
      }).catch(function (error) {
        Logger.error("resolveZoneFileToProfile: error fetching token file ".concat(tokenFileUrl, ": ").concat(error));
        reject(error);
      });
    } else {
      Logger.debug('Token file url not found. Resolving to blank profile.');
      resolve({});
    }
  });
}